import { useState } from "react";
import { Eraser } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { t } from "@/i18n";

export function ClearChat({ onClear, disabled = false }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className="chip chip-muted !py-1.5 ml-auto hover:text-[var(--status-error)] transition-colors disabled:opacity-40 disabled:pointer-events-none" onClick={() => setOpen(true)} disabled={disabled} data-testid="chat-clear-button">
        <Eraser size={13} /> {t("Clear chat")}
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="chat-clear-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{t("Clear this chat?")}</AlertDialogTitle>
            <AlertDialogDescription>{t("Your messages disappear from this screen. Questions already sent to the owner still get answered, and your OIs are not deleted.")}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="chat-clear-cancel">{t("Cancel")}</AlertDialogCancel>
            <AlertDialogAction onClick={onClear} data-testid="chat-clear-confirm">{t("Clear chat")}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
